// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api/v1/auth_service.proto (package journal.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { User } from "./user_service_pb";
import { file_api_v1_user_service } from "./user_service_pb";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import { file_google_api_field_behavior } from "../../google/api/field_behavior_pb";
import type { EmptySchema, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/auth_service.proto.
 */
export const file_api_v1_auth_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_v1_user_service, file_google_api_annotations, file_google_api_field_behavior, file_google_protobuf_empty, file_google_protobuf_timestamp]);

/**
 * @generated from message journal.api.v1.GetCurrentUserRequest
 */
export type GetCurrentUserRequest = Message<"journal.api.v1.GetCurrentUserRequest"> & {
};

/**
 * Describes the message journal.api.v1.GetCurrentUserRequest.
 * Use `create(GetCurrentUserRequestSchema)` to create a new message.
 */
export const GetCurrentUserRequestSchema: GenMessage<GetCurrentUserRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 0);

/**
 * @generated from message journal.api.v1.InstanceStatus
 */
export type InstanceStatus = Message<"journal.api.v1.InstanceStatus"> & {
  /**
   * Whether this instance has been setup (has an owner).
   * This field is for observability only - visible in devtools network tab.
   * Frontend should NOT use this field for business logic.
   * Instance initialization state is managed by backend logic.
   *
   * @generated from field: bool has_owner = 1;
   */
  hasOwner: boolean;

  /**
   * Instance version (for display/debugging purposes).
   *
   * @generated from field: string version = 2;
   */
  version: string;

  /**
   * Instance mode (e.g., "prod", "dev", "demo").
   *
   * @generated from field: string mode = 3;
   */
  mode: string;
};

/**
 * Describes the message journal.api.v1.InstanceStatus.
 * Use `create(InstanceStatusSchema)` to create a new message.
 */
export const InstanceStatusSchema: GenMessage<InstanceStatus> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 1);

/**
 * @generated from message journal.api.v1.GetCurrentUserResponse
 */
export type GetCurrentUserResponse = Message<"journal.api.v1.GetCurrentUserResponse"> & {
  /**
   * The authenticated user's information.
   *
   * @generated from field: journal.api.v1.User user = 1;
   */
  user?: User;

  /**
   * Instance status information (non-sensitive).
   * Contains only boolean state, not identity information.
   *
   * @generated from field: journal.api.v1.InstanceStatus instance_status = 2;
   */
  instanceStatus?: InstanceStatus;
};

/**
 * Describes the message journal.api.v1.GetCurrentUserResponse.
 * Use `create(GetCurrentUserResponseSchema)` to create a new message.
 */
export const GetCurrentUserResponseSchema: GenMessage<GetCurrentUserResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 2);

/**
 * @generated from message journal.api.v1.SignInRequest
 */
export type SignInRequest = Message<"journal.api.v1.SignInRequest"> & {
  /**
   * Authentication credentials. Provide one method.
   *
   * @generated from oneof journal.api.v1.SignInRequest.credentials
   */
  credentials: {
    /**
     * Username and password authentication.
     *
     * @generated from field: journal.api.v1.SignInRequest.PasswordCredentials password_credentials = 1;
     */
    value: SignInRequest_PasswordCredentials;
    case: "passwordCredentials";
  } | {
    /**
     * SSO provider authentication.
     *
     * @generated from field: journal.api.v1.SignInRequest.SSOCredentials sso_credentials = 2;
     */
    value: SignInRequest_SSOCredentials;
    case: "ssoCredentials";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message journal.api.v1.SignInRequest.
 * Use `create(SignInRequestSchema)` to create a new message.
 */
export const SignInRequestSchema: GenMessage<SignInRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 3);

/**
 * Nested message for password-based authentication credentials.
 *
 * @generated from message journal.api.v1.SignInRequest.PasswordCredentials
 */
export type SignInRequest_PasswordCredentials = Message<"journal.api.v1.SignInRequest.PasswordCredentials"> & {
  /**
   * The username to sign in with.
   *
   * @generated from field: string username = 1;
   */
  username: string;

  /**
   * The password to sign in with.
   *
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message journal.api.v1.SignInRequest.PasswordCredentials.
 * Use `create(SignInRequest_PasswordCredentialsSchema)` to create a new message.
 */
export const SignInRequest_PasswordCredentialsSchema: GenMessage<SignInRequest_PasswordCredentials> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 3, 0);

/**
 * Nested message for SSO authentication credentials.
 *
 * @generated from message journal.api.v1.SignInRequest.SSOCredentials
 */
export type SignInRequest_SSOCredentials = Message<"journal.api.v1.SignInRequest.SSOCredentials"> & {
  /**
   * The ID of the SSO provider.
   *
   * @generated from field: string idp_id = 1;
   */
  idpId: string;

  /**
   * The authorization code from the SSO provider.
   *
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * The redirect URI used in the SSO flow.
   *
   * @generated from field: string redirect_uri = 3;
   */
  redirectUri: string;

  /**
   * The PKCE code verifier for enhanced security (RFC 7636).
   * Optional - enables PKCE flow protection against authorization code interception.
   *
   * @generated from field: string code_verifier = 4;
   */
  codeVerifier: string;

  /**
   * If true, link this OAuth identity to the currently authenticated user.
   * Optional - enables adding login methods to existing accounts from settings page.
   * When true, the user must already be authenticated (valid access token required).
   * The OAuth identity will be linked to the current user instead of creating a new user.
   *
   * @generated from field: bool link_mode = 5;
   */
  linkMode: boolean;
};

/**
 * Describes the message journal.api.v1.SignInRequest.SSOCredentials.
 * Use `create(SignInRequest_SSOCredentialsSchema)` to create a new message.
 */
export const SignInRequest_SSOCredentialsSchema: GenMessage<SignInRequest_SSOCredentials> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 3, 1);

/**
 * @generated from message journal.api.v1.SignInResponse
 */
export type SignInResponse = Message<"journal.api.v1.SignInResponse"> & {
  /**
   * The authenticated user's information.
   *
   * @generated from field: journal.api.v1.User user = 1;
   */
  user?: User;

  /**
   * The short-lived access token for API requests.
   * Store in memory only, not in localStorage.
   *
   * @generated from field: string access_token = 2;
   */
  accessToken: string;

  /**
   * When the access token expires.
   * Client should call RefreshToken before this time.
   *
   * @generated from field: google.protobuf.Timestamp access_token_expires_at = 3;
   */
  accessTokenExpiresAt?: Timestamp;
};

/**
 * Describes the message journal.api.v1.SignInResponse.
 * Use `create(SignInResponseSchema)` to create a new message.
 */
export const SignInResponseSchema: GenMessage<SignInResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 4);

/**
 * @generated from message journal.api.v1.SignOutRequest
 */
export type SignOutRequest = Message<"journal.api.v1.SignOutRequest"> & {
};

/**
 * Describes the message journal.api.v1.SignOutRequest.
 * Use `create(SignOutRequestSchema)` to create a new message.
 */
export const SignOutRequestSchema: GenMessage<SignOutRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 5);

/**
 * @generated from message journal.api.v1.RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"journal.api.v1.RefreshTokenRequest"> & {
};

/**
 * Describes the message journal.api.v1.RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 6);

/**
 * @generated from message journal.api.v1.RefreshTokenResponse
 */
export type RefreshTokenResponse = Message<"journal.api.v1.RefreshTokenResponse"> & {
  /**
   * The new short-lived access token.
   *
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * When the access token expires.
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message journal.api.v1.RefreshTokenResponse.
 * Use `create(RefreshTokenResponseSchema)` to create a new message.
 */
export const RefreshTokenResponseSchema: GenMessage<RefreshTokenResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 7);

/**
 * UserIdentity represents an OAuth identity linked to a user.
 *
 * @generated from message journal.api.v1.UserIdentity
 */
export type UserIdentity = Message<"journal.api.v1.UserIdentity"> & {
  /**
   * The unique ID of the identity.
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * When the identity was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * When the identity was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp;

  /**
   * The ID of the user this identity belongs to.
   *
   * @generated from field: string user_id = 4;
   */
  userId: string;

  /**
   * The OAuth provider name (e.g., "Google", "X.com", "Apple").
   *
   * @generated from field: string provider = 5;
   */
  provider: string;

  /**
   * The provider's user identifier.
   *
   * @generated from field: string provider_id = 6;
   */
  providerId: string;

  /**
   * The email address from the provider (may be empty).
   *
   * @generated from field: string email = 7;
   */
  email: string;

  /**
   * Whether the email has been verified by the provider.
   *
   * @generated from field: bool email_verified = 8;
   */
  emailVerified: boolean;

  /**
   * The display name from the provider.
   *
   * @generated from field: string display_name = 9;
   */
  displayName: string;

  /**
   * The avatar URL from the provider.
   *
   * @generated from field: string avatar_url = 10;
   */
  avatarUrl: string;
};

/**
 * Describes the message journal.api.v1.UserIdentity.
 * Use `create(UserIdentitySchema)` to create a new message.
 */
export const UserIdentitySchema: GenMessage<UserIdentity> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 8);

/**
 * @generated from message journal.api.v1.ListUserIdentitiesRequest
 */
export type ListUserIdentitiesRequest = Message<"journal.api.v1.ListUserIdentitiesRequest"> & {
};

/**
 * Describes the message journal.api.v1.ListUserIdentitiesRequest.
 * Use `create(ListUserIdentitiesRequestSchema)` to create a new message.
 */
export const ListUserIdentitiesRequestSchema: GenMessage<ListUserIdentitiesRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 9);

/**
 * @generated from message journal.api.v1.ListUserIdentitiesResponse
 */
export type ListUserIdentitiesResponse = Message<"journal.api.v1.ListUserIdentitiesResponse"> & {
  /**
   * List of OAuth identities linked to the current user.
   *
   * @generated from field: repeated journal.api.v1.UserIdentity identities = 1;
   */
  identities: UserIdentity[];
};

/**
 * Describes the message journal.api.v1.ListUserIdentitiesResponse.
 * Use `create(ListUserIdentitiesResponseSchema)` to create a new message.
 */
export const ListUserIdentitiesResponseSchema: GenMessage<ListUserIdentitiesResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 10);

/**
 * @generated from message journal.api.v1.UnlinkIdentityRequest
 */
export type UnlinkIdentityRequest = Message<"journal.api.v1.UnlinkIdentityRequest"> & {
  /**
   * The ID of the identity to unlink.
   *
   * @generated from field: string identity_id = 1;
   */
  identityId: string;
};

/**
 * Describes the message journal.api.v1.UnlinkIdentityRequest.
 * Use `create(UnlinkIdentityRequestSchema)` to create a new message.
 */
export const UnlinkIdentityRequestSchema: GenMessage<UnlinkIdentityRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_auth_service, 11);

/**
 * @generated from service journal.api.v1.AuthService
 */
export const AuthService: GenService<{
  /**
   * GetCurrentUser returns the authenticated user's information.
   * Validates the access token and returns user details.
   * Similar to OIDC's /userinfo endpoint.
   *
   * @generated from rpc journal.api.v1.AuthService.GetCurrentUser
   */
  getCurrentUser: {
    methodKind: "unary";
    input: typeof GetCurrentUserRequestSchema;
    output: typeof GetCurrentUserResponseSchema;
  },
  /**
   * SignIn authenticates a user with credentials and returns tokens.
   * On success, returns an access token and sets a refresh token cookie.
   * Supports password-based and SSO authentication methods.
   *
   * @generated from rpc journal.api.v1.AuthService.SignIn
   */
  signIn: {
    methodKind: "unary";
    input: typeof SignInRequestSchema;
    output: typeof SignInResponseSchema;
  },
  /**
   * SignOut terminates the user's authentication.
   * Revokes the refresh token and clears the authentication cookie.
   *
   * @generated from rpc journal.api.v1.AuthService.SignOut
   */
  signOut: {
    methodKind: "unary";
    input: typeof SignOutRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * RefreshToken exchanges a valid refresh token for a new access token.
   * The refresh token is read from the HttpOnly cookie.
   * Returns a new short-lived access token.
   *
   * @generated from rpc journal.api.v1.AuthService.RefreshToken
   */
  refreshToken: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof RefreshTokenResponseSchema;
  },
  /**
   * ListUserIdentities returns all OAuth identities linked to the current user.
   * Requires authentication.
   *
   * @generated from rpc journal.api.v1.AuthService.ListUserIdentities
   */
  listUserIdentities: {
    methodKind: "unary";
    input: typeof ListUserIdentitiesRequestSchema;
    output: typeof ListUserIdentitiesResponseSchema;
  },
  /**
   * UnlinkIdentity removes an OAuth identity from the current user.
   * Requires authentication.
   *
   * @generated from rpc journal.api.v1.AuthService.UnlinkIdentity
   */
  unlinkIdentity: {
    methodKind: "unary";
    input: typeof UnlinkIdentityRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_v1_auth_service, 0);

